//
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Input, Button } from 'antd';
import { setCookie } from './../../hook';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Action
import send_auth from './actions/login.action';


// Style
import './style.css';

class Login extends Component {


    constructor(props) {
        super(props);
        // State
        this.state = {
            username: '', password: ''
        }
        this.onSubmitEvent = this.onSubmitEvent.bind( this );
    }

    onSubmitEvent( event ){
        event.preventDefault();
        this.props.send_auth( this.state);
    }

    componentWillReceiveProps(nextProps) {

        if( nextProps.auth.STATUS.CODE === '400' ){

            ReactDOM.render( <Error message={ nextProps.auth.STATUS.MESSAGE } />, document.getElementById('error_field') );

            setTimeout( function(){
                ReactDOM.unmountComponentAtNode(document.getElementById('error_field'));
            }, 2000 );

        } else if( nextProps.auth.STATUS.CODE === '200' ){
            const session = nextProps.auth.OUTPUT.AUTH.SESSION_ID;
            const user = nextProps.auth.OUTPUT.AUTH.USER + ',' + nextProps.auth.OUTPUT.AUTH.USER_ID+ ',' + nextProps.auth.OUTPUT.AUTH.USER_MAIL+ ',' + nextProps.auth.OUTPUT.AUTH.USER_ROLE+ ',' + nextProps.auth.OUTPUT.AUTH.FULL_NAME+ ',' + nextProps.auth.OUTPUT.AUTH.COMPANY_ID+ ',' + nextProps.auth.OUTPUT.AUTH.PERMISSION+ ',' + nextProps.auth.OUTPUT.AUTH.DEPARTMENT+ ',' + nextProps.auth.OUTPUT.AUTH.PICTURE

            setCookie('dv_hrms_auth', session, 1 );
            setCookie('dv_hrms_user', user, 1 );

            let current_route_path = sessionStorage.getItem('current_route_path');

            if( current_route_path ){
                this.props.history.push( current_route_path );
            } else {
                // Redirect to Dashboard
                this.props.history.push('/');
            }

        }

    }

    render() {
        return (
            <div>
                <div className="bg_image"></div>
                <div className="login-wrapper animated fadeIn">
                    <div className="login-header"></div>
                    <div className="login-forms">
                        <form method="post" autoComplete="off" onSubmit={ this.onSubmitEvent }>
                            <Input placeholder="User Name or Email" className="input" onChange={ (e) => this.setState({ username: e.target.value }) } />
                            <Input placeholder="Password" className="input" type="password" onChange={ (e) => this.setState({ password: e.target.value }) } />
                            <Button htmlType="submit" type="primary" className="button">Log in</Button>
                        </form>
                    </div>
                    <div id="error_field">

                    </div>
                    <div>
                        <Link className="forgot" to="/reset">Reset your password?</Link>
                    </div>
                    <div>
                        
                    </div>
                </div>
            </div>
        );
    }
}

const Error =( props )=> {
    return (
        <span className="error animated shake">{ props.message }</span>
    )
}

function mapStateToProps( state ){
    return {
        auth: state.login
    }
}

export default connect( mapStateToProps, { send_auth } )(Login);



// WEBPACK FOOTER //
// ./src/pages/login/index.js